import i18next from "i18next";
import apiCall from "./api";
import metrix from "metrix";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Activation from "components/activation";

const AppContext = createContext();

const languages = {
  english: "en",
  persian: "fa",
};
const themes = {
  dark: "dark",
  light: "light",
};

export const useAppContext = () => {
  return useContext(AppContext);
};

export const AppProvider = ({ children }) => {
  const navigate = useNavigate();
  const modalRef = useRef();
  const [theme, setTheme] = useState(themes.light);
  const [language, setLanguage] = useState(languages.persian);
  const [screen, setScreen] = useState(true);
  const [profile, setProfile] = useState(null);
  const [metrixInstance, setMetrixInstance] = useState(null);

  const instance = (options) => {
    return apiCall(handleONB, options);
  };

  useEffect(() => {
    const metrixInit = metrix.initialize({
      appId: "wiuurpdnvttjkee",
    });
    setMetrixInstance(metrixInit);
  }, []);

  useEffect(() => {
    updateTheme();
    updateLanguageDirection();
    changeLocalization();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme, language]);

  useEffect(() => {
    // detectThemePreference();
    window.addEventListener("orientationchange", handleOrientationChange);
    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  const handleOrientationChange = () => {
    const orientation = window?.screen?.orientation?.type;

    if (
      orientation !== "portrait-primary" &&
      orientation !== "portrait-secondary"
    ) {
      setScreen(false);
    } else {
      setScreen(true);
    }
  };

  const updateTheme = () => {
    const root = document.documentElement;
    const oppositeTheme = theme === themes.light ? themes.dark : themes.light;

    root.classList.remove(oppositeTheme);
    root.classList.add(theme);

    const themeColorMeta = document.getElementById("theme-color");
    themeColorMeta.content = theme === themes.dark ? "#000" : "#fff";
  };

  const updateLanguageDirection = () => {
    const direction = language === languages.english ? "ltr" : "rtl";
    document.body.setAttribute("dir", direction);
  };

  const changeLocalization = () => {
    if (language) {
      i18next.changeLanguage(language);
    }
  };

  // const detectThemePreference = () => {
  //   const prefersDark = window.matchMedia(
  //     "(prefers-color-scheme: dark)"
  //   ).matches;

  //   setTheme(prefersDark ? themes.dark : themes.light);

  //   const handleThemeChange = (e) => {
  //     setTheme(e.matches ? themes.dark : themes.light);
  //   };

  //   const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
  //   mediaQueryList.addEventListener("change", handleThemeChange);

  //   return () => {
  //     mediaQueryList.removeEventListener("change", handleThemeChange);
  //   };
  // };

  const handleONB = () => {
    modalRef?.current?.showModal();
  };

  const onActivationClick = () => {
    navigate("/onboarding");
    modalRef?.current?.hideModal();
  };

  return (
    <AppContext.Provider
      value={{
        theme,
        setTheme,
        language,
        setLanguage,
        screen,
        instance,
        profile,
        setProfile,
        metrixInstance,
      }}
    >
      {children}
      <Activation modalRef={modalRef} onClick={onActivationClick} />
    </AppContext.Provider>
  );
};
